import React from "react";
import get from "lodash/get";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import formHelper from "home/helper/form";
import Request from "config/Request";
import { ButtonValidation } from "component/Button.js";
import { SelectQuery, Base } from "component";
import Lib from "utils/Lib";

export default class ModalMoveAssets extends Base.PureComponent {
  constructor(props) {
    super(props);

    this.defaultState = {
      isOpen: false,
      isLoading: false,
      site: null,
      location: null
    };

    this.state = {
      ...this.state,
      ...this.defaultState
    };

    this.assets = [];
    this.location = null;
    this._location = { ref: null };
  }

  siteChangeHandler = val => {
    this.setState({ site: val, location: null }, () =>
      this._location.ref.reload("", true)
    );
  };

  locationChangeHandler = val => {
    this.setState({ location: val });
  };

  successHandler = () => {
    Lib.responseMessage(
      "success",
      "All assets in this location moved successfully."
    );
    this.props.onSuccess();
    this.close();
  };

  failedHandler = () => {
    Lib.responseMessage(
      "error",
      "There is an error when moving some assets, please try again."
    );
  };

  filterLocation = locations => {
    const filterFunc = l => l.Alias !== this.location.alias;
    return locations.filter(filterFunc);
  };

  open = (location, assets) => {
    this.assets = assets;
    this.location = location;
    this.setState({ isOpen: true });
  };

  close = () => {
    if (this.state.isLoading) return;
    this.setState({ isOpen: false });
    this.props.onClose();
  };

  move = () => {
    const s = this.state;

    if (
      !formHelper.ValidateFormMoveAsset({ Site: s.site, Location: s.location })
    )
      return;

    this.setState({ isLoading: true }, async () => {
      let res = null;
      const failed = [];

      for (const asset of this.assets) {
        res = await Request(
          "patch",
          "move-asset",
          {
            Authorization: "Bearer " + this.props.UserReducer.token
          },
          {
            Site: s.site.value,
            Location: s.location.value,
            DueDate: null,
            Force: true
          },
          [asset.Alias],
          undefined,
          undefined,
          undefined,
          null
        );

        if (!res) failed.push(asset);
      }

      this.setState({ isLoading: false }, () => {
        if (!!failed.length) {
          this.assets = failed;
          this.failedHandler();
        } else {
          this.successHandler();
        }
      });
    });
  };

  render() {
    return (
      <Modal isOpen={this.state.isOpen} toggle={this.close}>
        <ModalHeader toggle={this.close}>Move Assets / Tools</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-sm-12">
              <div className="row">
                <div className="col-12 mb-4">
                  <strong>{this.assets.length} assets</strong> found in the
                  location, please move the asstes to other location.
                </div>
                <div className="form-group col-sm-6">
                  <label htmlFor="site">Site</label>
                  <SelectQuery
                    name="Site"
                    placeholder="Type Site"
                    urlKey="read-site-autocomplete"
                    valKey="Alias"
                    valLabel="Name"
                    value={this.state.site}
                    disabled={this.state.isLoading}
                    onChange={this.siteChangeHandler}
                    UserReducer={this.props.UserReducer}
                  />
                </div>
                <div className="form-group col-sm-6">
                  <label htmlFor="to">Location</label>
                  <SelectQuery
                    name="Location"
                    placeholder="Type Location"
                    urlKey="read-location-autocomplete"
                    valKey="Alias"
                    valLabel="Name"
                    value={this.state.location}
                    extra={"site=" + get(this.state.site, "value", null)}
                    disabled={this.state.isLoading}
                    filterOptions={this.filterLocation}
                    onChange={this.locationChangeHandler}
                    onRef={n => (this._location.ref = n)}
                    UserReducer={this.props.UserReducer}
                  />
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonValidation
            color="default"
            is_process={this.state.isLoading}
            onClick={this.close}
          >
            Cancel
          </ButtonValidation>
          <ButtonValidation
            is_process={this.state.isLoading}
            onClick={this.move}
          >
            Move
          </ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}

ModalMoveAssets.defaultProps = {
  ...Base.PureComponent.defaultProps,
  onSuccess: () => null,
  onClose: () => null
};



// WEBPACK FOOTER //
// ./src/App/location/location/helper/component/ModalMoveAssets.jsx